import get from 'lodash/get'
import {createSelector} from 'reselect'
import hasSubmitSucceeded from 'redux-form/lib/hasSubmitSucceeded'

import {ApiRequestStates, REDUX} from '../const'

// Get

export const user = (state) => get(state, 'user')
export const email = (state) => get(state, 'user.email')
export const firstName = (state) => get(state, 'user.firstName', '')
export const id = (state) => get(state, 'user.id')
export const lastName = (state) => get(state, 'user.lastName', '')
export const version = (state) => get(state, 'user.version')
export const accountBalance = (state) => get(user(state), 'accountBalance')
export const fetchAccountBalanceStatus = (state) => get(user(state), 'fetchAccountBalanceStatus')
export const itemizedAccountBalances = (state) => get(user(state), 'itemizedAccountBalances')

// Boolean

export const isUserAndEventPending = (state) => !!get(state, 'user.isUserAndEventPending')

// Computed

export const isAuthenticated = createSelector(id, ($id) => !!$id)

/**
 * Check if we're currently fetching account balance information
 * @returns {Boolean}
 */
export const isFetchAccountBalanceStatusPending = createSelector(
  fetchAccountBalanceStatus,
  ($fetchAccountBalanceStatus) => $fetchAccountBalanceStatus === ApiRequestStates.PENDING,
)

/**
 * Check if we've encountered an error fetching the account balance
 * @returns {Boolean}
 */
export const isFetchAccountBalanceStatusError = createSelector(
  fetchAccountBalanceStatus,
  ($fetchAccountBalanceStatus) => $fetchAccountBalanceStatus === ApiRequestStates.ERROR,
)

// Forms

export const successfulAccountInfoPasswordFormSubmit = hasSubmitSucceeded(
  REDUX.ACCOUNT_INFO_PASSWORD_FORM,
)
export const successfulAccountInfoUserFormSubmit = hasSubmitSucceeded(REDUX.ACCOUNT_INFO_USER_FORM)
export const successfulAccountPasswordResetFormSubmit = hasSubmitSucceeded(
  REDUX.ACCOUNT_PASSWORD_RESET_FORM,
)
